export default "/images/vendor/flag-icon-css/flags/4x3/zm.svg?864bd087d50f237db5ce1a48f664a1eb";